<rt-report-parameters
    [controlNames]="controlNames"
    (getReport)="onGetReportClick($event)"
    (cancelReport)="onCancelClick()"
>
</rt-report-parameters>
<div *ngIf="displayReport" class="railroad-grid-container">
    <dx-data-grid
        id="bdsReportGrid"
        [dataSource]="gridSource"
        height="80vh"
        minHeight="200px"
        [showBorders]="true"
        [allowColumnResizing]="true"
        [columnAutoWidth]="true"
        [wordWrapEnabled]="true"
    >
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..."></dxo-search-panel>
        <dxo-group-panel [visible]="true"></dxo-group-panel>
        <dxo-grouping [autoExpandAll]="true"></dxo-grouping>
        <dxo-scrolling mode="virtual"></dxo-scrolling>

        <dxi-column
            dataField="dest_state"
            caption="Destination State"
            [groupIndex]="0"
        ></dxi-column>
        <dxi-column dataField="orig_city" caption="Origin City"></dxi-column>
        <dxi-column dataField="orig_state" caption="Origin State"></dxi-column>
        <dxi-column
            dataField="days"
            caption="Days En Route"
            dataType="number"
            [sortIndex]="0"
            sortOrder="asc"
        ></dxi-column>
        <dxi-column dataField="trips" caption="Trips" dataType="number"></dxi-column>
        <dxi-column dataField="cum_trips" caption="Cumulative Trips" dataType="number"></dxi-column>
        <dxi-column
            dataField="cum_trips_all"
            caption="Cumulative Trips (All Origins)"
            dataType="number"
        ></dxi-column>
    </dx-data-grid>
</div>
